import { EditFormView as EditFormViewwWeb } from '@tuqqi/web';

import { withStyles } from '@material-ui/core';
import { NewUiWrapper } from '@tuqqi/web';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { compose } from 'recompose';
import { store } from '../../../..';
import ViewDefaultFormVIew from './ViewDefaultFormVIew';

const styles = theme => ({
    wrap: {

    }
});

const EditFormView = (props) => {
	const {dispatch, mappings, defaultInputTemplates} = props
	const [currentItemId, setCurrentItemId] = useState()
	const [isCreating, setIsCreating] = useState(false)
	const [isReadonly, setIsReadOnly] = useState(false)
	const defaultDataTypes = defaultInputTemplates.map(x => x.dataType)
	const oldInput = isReadonly && currentItemId ? defaultInputTemplates.find(x => x.dataType === currentItemId) : null;

	const currentItem = isCreating || !currentItemId ? null : mappings.find(x => x.id + '' === currentItemId + '')

	useEffect(() => {
		const id = window.location.pathname.split('/').pop();
		if(defaultDataTypes.includes(id)) {
			setCurrentItemId(id)
			setIsCreating(false)
			setIsReadOnly(true)
			return
		}
		const isNew = !id
		if(isNew) {
			setIsCreating(true)
			setIsReadOnly(false)
			setCurrentItemId(undefined)
			return
		}

		const map = mappings.find(x => x.id + '' === id + '')
		if(!map) {

			return
		}
		setIsCreating(false)
		setIsReadOnly(false)
		setCurrentItemId(map.id)
	}, [mappings])

	const handleNavigateCustomInputToEdit = (mapping) => {
		
		const param = mapping ? mapping?.id : ""
		console.log("mapping.id",mapping?.id)
		dispatch(push(`/admin/custominputmappings/create/${param}`));
	}

	const handleNavigateToForms = () => {
		dispatch(push('/admin/custominputmappings'));
	}

    const callbacks = {
		handleNavigateCustomInputToEdit,
		handleNavigateToForms,
    }

	if(isReadonly && oldInput) {
		return <NewUiWrapper store={store} callbacks={callbacks}>
        	<ViewDefaultFormVIew oldInput={oldInput} />
    	</NewUiWrapper>
	}

	if(!currentItem && !isCreating) return null

    return <NewUiWrapper store={store} callbacks={callbacks}>
        <EditFormViewwWeb isReadonly={false} isCreating={isCreating} customInputMapping={currentItem} />
    </NewUiWrapper>}

const mapStateToProps = (state) => ({
	customInputService: state.services.customInputService,
	globalData: state.globalData,
	defaultInputTemplates: state.globalData.defaultInputTemplates ?? [],
	mappings: state.data.globalData.customInputMappings?.data ?? [],
})

const mapDispatchToProps = dispatch => {
    return { dispatch }
}

export default compose(withStyles(styles),
    connect(
        mapStateToProps,
        mapDispatchToProps
))(EditFormView);
